// React
import { useState } from 'react';
import { useForm } from 'react-hook-form';
// ユーティリティ
import { validationSchema } from '../../../utils/validationUtils';
import { errorMessages } from '../../../utils/messagesUtils';

import sty from './ForgotPassword.module.css';

const ForgotPasswordInput = ({ setIsSuccess, role }) => {
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: 'onBlur', // フォーカスが外れた時バリデーションを実行
    });
    const [errorFromServer, setErrorFromServer] = useState('');

    const onSubmit = async (data) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/password/forgot`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ ...data, "role": role }),
                credentials: 'include'
            });
            const result = await response.json();
            if (response.status === 200 && result.status == 'OK') {
                setIsSuccess(true); // 成功時に親コンポーネントの状態を更新
            } else {
                setIsSuccess(false);
                setErrorFromServer(errorMessages.account_settings.send_code_failed);
            }
        } catch (e) {
            setErrorFromServer(errorMessages.api.server_error);
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="page-tit">
                <div className="page-tit-outer">
                    <p className="page-tit-txt">
                        パスワードをお忘れの方
                    </p>
                    <div className="page-tit-border"></div>
                </div>
            </div>
            <div className="inner-container">
                {errorFromServer && <p className='account-error-msg'>{errorFromServer}</p>}
                <div className={sty['forgot__mail']}>
                    <div className={sty['forgot__mail-tit']}>
                        <p className={sty['forgot__line-break']}>
                            {`メールアドレスを入力してください\nパスワード再設定のためのメールを送信します`}
                        </p>
                        <input {...register('email', validationSchema.email)}
                            id="email"
                            className={sty['forgot__email-input']}
                            autoComplete="email"
                            placeholder="taro.yamada@example.com"
                        />
                        {errors.email && <p className="form__validation-msg">{errors.email.message}</p>}
                    </div>
                </div>
                <div className="primary-btns">
                    <button type="submit" className="primary-btn btn-large">送信</button>
                </div>
            </div>
        </form>
    );
};

export default ForgotPasswordInput;